module.exports = __webpack_public_path__ + "img/bwg_btn.edb18780.png";